<div id="layout" class="sign_in f_col">
  <app-view-title *ngIf="this.actualPerson" fromRoute="pre-enroll" [chooseLangBtn]="false">{{this.actualPerson?.firstName + ' ' + this.actualPerson?.lastName}}</app-view-title>

  <div class="scroll_wrapper resp_wrapper">
    <div class="resp_c-50 resp_scroll-wrapper_l">
        <div>
          <app-view-deco-image imageUrl="assets/images/image_male.svg"></app-view-deco-image>
          <app-snackbar class="f_center mb_20" type="valid" Icon="check">{{'global.ready' | translate}}</app-snackbar>
        </div>
        <div>
          <form *ngIf="form" class="f_col gap_20" id="form" [formGroup]="form" (ngSubmit)="submit()">
            <app-input *ngIf="api.env.personFields.indexOf('firstName') > -1"
                      formCtrlName="firstName" [formGrp]="form" class="mb_5" label="form.firstName" icon="user"></app-input>
            <app-input *ngIf="api.env.personFields.indexOf('lastName') > -1"
                      formCtrlName="lastName" [formGrp]="form" class="mb_5" label="form.lastName" icon="user"></app-input>
            <app-input *ngIf="api.env.personFields.indexOf('nationalNumber') > -1"
                      formCtrlName="personalNr" [formGrp]="form" class="mb_5" label="global.personalNum" icon="hashtag"></app-input>
            <app-input *ngIf="api.env.personFields.indexOf('passportNumber') > -1"
                      class="mb_5" formCtrlName="passportNr" [formGrp]="form" label="global.passportNum" icon="hashtag"></app-input>
            <app-input *ngIf="api.env.personFields.indexOf('birthDate') > -1"
                      class="mb_5" formCtrlName="birthDate" [formGrp]="form" type="date" label="form.birthDate" icon="calendar"></app-input>
            <app-input *ngIf="api.env.personFields.indexOf('sex') > -1"
                      class="mb_5" formCtrlName="sex" [formGrp]="form" type="select" label="form.sex" icon="gender" [selectOptions]="sexOptions"></app-input>
            <app-input *ngIf="api.env.personFields.indexOf('birthPlaceCity') > -1"
                      class="mb_5" formCtrlName="birthPlaceCity" [formGrp]="form" label="form.placeOfBirth" icon="location_city"></app-input>
            <app-input *ngIf="api.env.personFields.indexOf('birthPlaceCountry') > -1"
                      class="mb_5" formCtrlName="birthPlaceCountry" [formGrp]="form" type="select" label="form.birthCountry" icon="flag" [selectOptions]="countriesOptions"></app-input>
            <app-input *ngIf="api.env.personFields.indexOf('linkType') > -1"
                      class="mb_5" [formGrp]="form" type="select" formCtrlName="linkType" label="form.linkType" icon="list" [selectOptions]="linkTypeOptions"></app-input>
            <app-input *ngIf="api.env.personFields.indexOf('linkType') > -1 && otherOptions"
                      formCtrlName="otherLinkType" [formGrp]="form" class="mb_5" disabled="true" label="form.otherLinkType" icon="link"></app-input>
            <app-button type="submit" formId="form" class="modification-save resp_maxSize_l">{{'global.save' | translate}}</app-button>
            <div class="flex gap_10">
              <app-button size="xsm" color="transparent" border="true" formId="form" class="resp_minSize_l fullWidth" (btnClicked)="nav.goBack()">{{'global.back' | translate}}</app-button>
              <app-button size="xsm" type="submit" formId="form" class="modification-save resp_minSize_l" [disabled]="form.invalid || !(form.get('firstName').value || form.get('lastName').value)">{{'global.save' | translate}}</app-button>
            </div>
            <app-errors-list [dark]="true" *ngIf="submitted" [formErrors]="this.forms.getFormErrors(this.form)"></app-errors-list>
          </form>
        </div>
    </div>
    <div class="btns-container">
      <div class="fullWidth flex f_center">
        <div class="menuButton-container flex f_center">
        </div>
      </div>
    </div>
  </div>
  <div class="flex gap_10 mb_20">
    <app-back-btn class="resp_maxSize_l" icon="house" [navTo]="{route: 'dashboard'}"></app-back-btn>
    <div class="ml_10 fullWidth">
      <app-button color="transparent" border="true" formId="form" class=" resp_maxSize_l fullWidth" (btnClicked)="nav.goBack()">{{'global.back' | translate}}</app-button>
    </div>
  </div>
</div>
